<div class="Error">

    <h2>Erro ao Editar o Orçamento</h2>
    <button (click)="close()">
        <span>Fechar</span>
    </button>
</div>
